module.exports = __webpack_public_path__ + "static/media/linkedin-logo.46dd0b5e.png";